import * as React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { dataSideBar } from './constant';

import MarkChatReadIcon from '@mui/icons-material/MarkChatRead';
import SmsFailedIcon from '@mui/icons-material/SmsFailed';
import ReviewsIcon from '@mui/icons-material/Reviews';
import MessageIcon from '@mui/icons-material/Message';
import { useSelector } from 'react-redux';
import { IReduxState } from '../store';


export default function SideBar(props: any) {
    const { selectedIndex, setSelectedIndex} = props;

    const messages = useSelector((state: IReduxState) => state.messagerie).messages;
    const handleListItemClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, index: number,) => { setSelectedIndex(index) };

    

    return (
        <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
            <List component="nav" aria-label="main mailbox folders">
                {dataSideBar.map((item, index: number) => (
                    <ListItemButton
                        selected={selectedIndex === index}
                        onClick={(event) => handleListItemClick(event, index)}
                    >
                        <ListItemIcon>
                            {item.id === 0 && <MessageIcon />}
                            {item.id === 1 && <MarkChatReadIcon />}
                            {item.id === 2 && <SmsFailedIcon />}
                            {item.id === 3 && <ReviewsIcon />}
                        </ListItemIcon>
                        <ListItemText primary={item.label} />
                    </ListItemButton>
                ))}
            </List>
        </Box>
    );
}
